import { IdStyles } from "../less/IdStyles";
export var IdFontWithOutlines = [
    IdStyles.HeadlineOne,
    IdStyles.HeadlineAccent,
    IdStyles.TextBoldSecondaryOutline,
    IdStyles.TextSmallBoldSecondaryOutline,
    IdStyles.TextPositive,
    IdStyles.TextNegative,
    IdStyles.TextButtonDefault,
];
export var isFontOutlines = function (style) {
    return IdFontWithOutlines.indexOf(style) >= 0;
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdFontWithOutlines.ts
// module id = 475
// module chunks = 3